import { render, staticRenderFns } from "./CreateTeamStore.vue?vue&type=template&id=51a3a16a"
import script from "./CreateTeamStore.vue?vue&type=script&lang=js"
export * from "./CreateTeamStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports